export default {
  methods: {
        safeBooleanUpdate(value) {
            if (typeof value === 'string') {
                if (value === '1' || value.toLowerCase() === 'yes' || value.toLowerCase() === 'true') {
                    value = true;
                } else if (value === '0' || value.toLowerCase() === 'no' || value.toLowerCase() === 'false') {
                    value = false;
                } else {
                    value = null;
                }
            } else if (typeof value === 'number') {
                if (value === 1) {
                    value = true;
                } else if (value === 0) {
                    value = false;
                } else {
                    value = null;
                }
            }

            return value;
        }
    }
}